var Backbone = require('backbone');

module.exports = Backbone.View.extend({
    initialize: function () {
        console.log('Page 404');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/NotFound/NotFound.js
// module id = 58
// module chunks = 0